export const HEADER_SESSIONID = "X-OWA-SessionId";
export const HEADER_CORRELATIONID = "X-OWA-CorrelationId";
export const HEADER_SCENARIONAME = "X-ScenarioName";
export const HEADER_SCENARIOGUID = "X-ScenarioGuid";
export const HEADER_PROVENANCEID = "X-OWA-ProvenanceId";
export const HEADER_URLPOSTDATA = "X-OWA-UrlPostData";
export const HEADER_WEBSSESSIONTYPE = "X-OwaWebSessionType";
export const HEADER_ANCHORMAILBOX = "X-AnchorMailbox";
export const HEADER_ROUTINGPARAMETER_SESSIONKEY = "X-RoutingParameter-SessionKey";
export const HEADER_EXPLICITLOGONUSER = "X-OWA-ExplicitLogonUser";
